import { Box, Typography } from "@mui/material";

const StoreHeader = ({ totalStrategies }) => {
  return (
    <Box sx={{ mb: 3 }}>
      <Typography variant="h4" sx={{ fontWeight: 700, color: "text.primary", mb: 0.5 }}>
        Strategy{" "}
        <Box component="span" sx={{ color: "primary.main" }}>
          Store
        </Box>
      </Typography>
      {totalStrategies != null && (
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          Explore {totalStrategies} investment strategies
        </Typography>
      )}
    </Box>
  );
};

export default StoreHeader;
